<nav class="navbar navbar-expand-sm navbar-dark fixed-top" style="background-color: rgb(51,51,51)"
  *ngIf="this.username !== null">
  <div class="navbar-expand-md">
    <a class="navbar-brand" [routerLink]="['/']" routerLinkActive="router-link-active">
      <i class="fa fa-home fa-lg"></i>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <!-- Opções de Menu -->
    <ul class="navbar-nav me-auto">
      <li class="nav-item active" *ngIf="GetPermission(6001)">
        <a class="nav-link" [routerLink]="['/contratos']" routerLinkActive="router-link-active">Contratos </a>
      </li>
      <li class="nav-item active" *ngIf="GetPermission(6002)">
        <a class="nav-link" [routerLink]="['/documentos']" routerLinkActive="router-link-active">Documentos </a>
      </li>
      <li class="nav-item active" *ngIf="GetPermission(6003)">
        <a class="nav-link" [routerLink]="['/pedidoIntervencao']" routerLinkActive="router-link-active">Intervenções
        </a>
      </li>
      <li class="nav-item active" *ngIf="GetPermission(6005)">
        <a class="nav-link" [routerLink]="['/logistica']" routerLinkActive="router-link-active">Logística </a>
      </li>
    </ul>

    <!-- Profile -->
    <div class="navbar-expand">
      <ul class="navbar-nav">
        <li class="nav-item" style="vertical-align: middle;padding-top: 20px;">
          <div class="progress progress-xs"
            style="width: 80px;height:6px;margin: 0;padding: 0;max-height: 10px;line-height: 0;"
            [attr.title]="loginExpireProgress">
            <div class="progress-bar"
              [ngClass]="{'bg-success': loginExpireProgress >= 20, 'bg-warning': loginExpireProgress < 20 && loginExpireProgress >= 10, 'bg-danger progress-bar-striped progress-bar-animated': loginExpireProgress < 10 }"
              role="progressbar" [style.width]="loginExpireProgress+'%'" [attr.aria-valuenow]="loginExpireProgress"
              aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </li>
        &nbsp;

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{name}}
          </a>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
            <a *ngIf="azureAD == false" class="dropdown-item" href="#" [routerLink]="['/changepassword']">Alterar
              Password</a>
            <div *ngIf="azureAD == false" class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" (click)="logout()"> Sair</a>
          </div>
        </li>
        <li class="nav-item">&nbsp;</li>
      </ul>
    </div>
  </div>

</nav>